module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2r7n4r-989a72336eaf49709a22b7fec6723972.svg";